import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import Slider from "@mui/material/Slider";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import {
  getSpatialPropertySliderValues,
  SpatialPropertyType,
} from "../../../interfaces/robot/cleaning-configurations/spatialProperty";
import FormHelperText from "@mui/material/FormHelperText";

const SpatialPropertySlider: React.FC<{
  value: SpatialPropertyType | null;
  hideLabel?: boolean;
  isBlockStorageAllowed?: boolean;
  onChange: (value: SpatialPropertyType) => void;
}> = ({ value, hideLabel, isBlockStorageAllowed, onChange }) => {
  const { t } = useTranslation();

  const spatialPropertyTypes = getSpatialPropertySliderValues(isBlockStorageAllowed);

  const [sliderState, setSliderState] = useState(value);

  useEffect(() => {
    setSliderState(value);
  }, [value]);

  const sliderChangeHandler = (event: Event, value: number | number[], _: number) => {
    setSliderState(spatialPropertyTypes.find((v) => v.value === (value as number))?.type as SpatialPropertyType);
  };

  const sliderConfirmHandler = () => {
    if (sliderState != null) {
      onChange(sliderState);
    }
  };

  const displayValue = spatialPropertyTypes.find((v) => v.type === sliderState)?.value;
  const maxValue = spatialPropertyTypes.sort((a, b) => b.value - a.value)[0].value;
  if (value == null || displayValue == null || maxValue == null) {
    return null;
  }

  return (
    <React.Fragment>
      <Stack>
        {hideLabel !== true && <InputLabel>{t("configuration-cleaning-spatialProperty")}</InputLabel>}
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Button size="small" sx={{ minWidth: "max-content" }} onClick={() => onChange(SpatialPropertyType.Static)}>
            {t(SpatialPropertyType.Static)}
          </Button>
          <Slider
            value={displayValue}
            onChange={sliderChangeHandler}
            min={0}
            max={maxValue}
            step={1}
            valueLabelDisplay="off"
            onChangeCommitted={sliderConfirmHandler}
          />
          <Button size="small" sx={{ minWidth: "max-content" }} onClick={() => onChange(SpatialPropertyType.Dynamic)}>
            {t(SpatialPropertyType.Dynamic + ".label")}
          </Button>
        </Stack>
        <FormHelperText>{t(sliderState ?? "")}</FormHelperText>
      </Stack>
    </React.Fragment>
  );
};

export default SpatialPropertySlider;
